import { environment } from '../environment/environment';
import { headersAutorization } from '../helpers/headerAutorization';
import http from '../helpers/http';
const url = environment.apiUrl;
export const getLasMaintenance = async () => {
  return http.get(`${url}/maintenance/last`, headersAutorization());
};
